import SelectOptionColorLabel from '../SelectOptionColorLabel'

export type SelectOptionColorMeta = {
  label?: unknown
  title?: string
  color?: string | null
  value?: string | number | null
  [key: string]: unknown
}

export const getSelectOptionSearchText = (
  option?: SelectOptionColorMeta | null,
) => {
  if (!option) return ''

  const title = option.title
  if (typeof title === 'string' && title.trim()) {
    return title.trim()
  }

  const label = option.label
  if (typeof label === 'string') {
    return label.trim()
  }

  return ''
}

export const enhanceSelectOptionsWithColors = <T extends SelectOptionColorMeta>(
  options: T[] | undefined,
  showOptionColors?: boolean,
): T[] => {
  if (!showOptionColors || !options?.length) {
    return options ?? []
  }

  return options.map((option) => {
    const searchText = getSelectOptionSearchText(option)
    const color = String(option.color ?? '').trim()

    if (!color || !searchText) {
      return option.title != null
        ? option
        : { ...option, title: searchText || undefined }
    }

    return {
      ...option,
      title: searchText,
      label: (
        <SelectOptionColorLabel color={color}>
          {searchText}
        </SelectOptionColorLabel>
      ),
    }
  })
}
